
export async function loadWorker() {
  return import('worker-module:/home/runner/work/vertex-web-sdk/vertex-web-sdk/packages/viewer/src/workers/png-decoder.ts');
}
